import { BoxTitles } from "@boxes/BoxTitles";
import { BaseCurrencyInput, Button, Checkbox, Drawer } from "@components";
import styles from "@styles/forms-flow/filtered-audience.module.scss";
import classNames from "classnames/bind";
import React from "react";

const css = classNames.bind(styles);

const CLIMATE_TYPES = {
  TEMPERATURE: "temperature",
  THERMAL_SENSATION: "thermalSensation",
};

const CLIMATE_FEATURE = {
  CLEAR: "clear",
  RAIN: "rain",
  CLOUDY: "cloudy",
  PARTLY_CLOUDY: "partly_cloudy",
};

export class ClimateProfileFilterForm extends React.Component {
  state = {
    payload: null,
    collapsed: null,
  };

  get defaultPayload() {
    return {
      temperature: {
        selected: false,
        temperatureType: null,
        min: null,
        max: null,
      },
      moisture: {
        selected: false,
        min: null,
        max: null,
      },
      weather: {
        selected: false,
        values: [],
      },
      rain: {
        selected: false,
        min: null,
        max: null,
      },
      quantity: {
        exact: 0,
      },
    };
  }

  componentDidMount() {
    const { node } = this.props;
    this.setState({
      payload: {
        ...this.defaultPayload,
        ...node.data,
      },
    });
  }

  setPayloadKeyValue(key, value) {
    const { node, onChange } = this.props;
    const { payload } = this.state;
    this.setState({
      payload: {
        ...payload,
        [key]: {
          ...(payload[key] || {}),
          ...value,
        },
      },
    });

    onChange && onChange({ ...node, data: { ...node.data, ...payload } });
  }

  renderTemperature() {
    const { collapsed } = this.state;
    const { temperature } = this.state.payload || { temperature: {} };

    return (
      <div className={styles.climateVariant}>
        <div
          className={styles.header}
          onClick={() =>
            this.setState({
              collapsed: collapsed === "temperature" ? null : "temperature",
            })
          }
        >
          <div className="d-flex align-center">
            <Checkbox
              checked={temperature?.selected}
              onClick={() => {
                this.setPayloadKeyValue("temperature", {
                  selected: !temperature?.selected,
                });
              }}
            />
            <p>Temperatura</p>
          </div>
          <i
            className={css({
              "fal fa-chevron-down": true,
              collapsed: collapsed === "temperature",
            })}
          />
        </div>

        {collapsed === "temperature" && (
          <div className={styles.content}>
            <p className={styles.label}>Você deseja usar:</p>
            <div className={styles.options}>
              <div
                className={css({
                  option: true,
                  selected:
                    temperature?.temperatureType === CLIMATE_TYPES.TEMPERATURE,
                })}
                onClick={() =>
                  this.setPayloadKeyValue("temperature", {
                    temperatureType:
                      temperature.temperatureType === CLIMATE_TYPES.TEMPERATURE
                        ? null
                        : CLIMATE_TYPES.TEMPERATURE,
                  })
                }
              >
                <i className="fal fa-temperature-half" />
                <p>Temperatura</p>
              </div>
              <div
                className={css({
                  option: true,
                  selected:
                    temperature?.temperatureType ===
                    CLIMATE_TYPES.THERMAL_SENSATION,
                })}
                onClick={() =>
                  this.setPayloadKeyValue("temperature", {
                    temperatureType:
                      temperature.temperatureType ===
                      CLIMATE_TYPES.THERMAL_SENSATION
                        ? null
                        : CLIMATE_TYPES.THERMAL_SENSATION,
                  })
                }
              >
                <i className="fal fa-heat" />
                <p>Sensação térmica</p>
              </div>
            </div>

            <p className={styles.label}>Defina a faixa</p>
            <div className="d-flex align-center mt-25">
              <BaseCurrencyInput
                className="w-100 mr-15"
                suffix={" °"}
                prefix={""}
                precision={0}
                label="Faixa mín"
                value={temperature.min}
                onChange={(value) => {
                  this.setPayloadKeyValue("temperature", {
                    min: value,
                  });
                }}
              />
              <BaseCurrencyInput
                className="w-100"
                suffix={" °"}
                prefix={""}
                precision={0}
                label="Faixa máx"
                value={temperature.max}
                onChange={(value) => {
                  this.setPayloadKeyValue("temperature", {
                    max: value,
                  });
                }}
              />
            </div>
          </div>
        )}
      </div>
    );
  }

  renderMoisture() {
    const { collapsed } = this.state;
    const { moisture } = this.state.payload || { moisture: {} };

    return (
      <div className={styles.climateVariant}>
        <div
          className={styles.header}
          onClick={() =>
            this.setState({
              collapsed: collapsed === "moisture" ? null : "moisture",
            })
          }
        >
          <div className="d-flex align-center">
            <Checkbox
              checked={moisture?.selected}
              onClick={() => {
                this.setPayloadKeyValue("moisture", {
                  selected: !moisture?.selected,
                });
              }}
            />
            <p>Umidade</p>
          </div>

          <i
            className={css({
              "fal fa-chevron-down": true,
              collapsed: collapsed === "moisture",
            })}
          />
        </div>

        {collapsed === "moisture" && (
          <div className={styles.content}>
            <p className={styles.label}>Defina a faixa</p>
            <div className="d-flex align-center mt-25">
              <BaseCurrencyInput
                className="w-100 mr-15"
                suffix={" %"}
                prefix={""}
                precision={0}
                label="Faixa mín"
                max="5"
                value={moisture?.min}
                onChange={(value) => {
                  this.setPayloadKeyValue("moisture", {
                    min: value,
                  });
                }}
              />
              <BaseCurrencyInput
                className="w-100"
                suffix={" %"}
                prefix={""}
                precision={0}
                label="Faixa máx"
                max="5"
                value={moisture?.max}
                onChange={(value) => {
                  this.setPayloadKeyValue("moisture", {
                    max: value,
                  });
                }}
              />
            </div>
          </div>
        )}
      </div>
    );
  }

  renderWeatheRain() {
    const { collapsed } = this.state;
    const { weather, rain } = this.state.payload || { weather: {}, rain: {} };

    return (
      <div className={styles.climateVariant}>
        <div
          className={styles.header}
          onClick={() =>
            this.setState({
              collapsed:
                collapsed === "characteristics" ? null : "characteristics",
            })
          }
        >
          <div className="d-flex align-center">
            <Checkbox
              checked={weather.selected}
              onClick={() => {
                this.setPayloadKeyValue("weather", {
                  selected: !weather.selected,
                });
              }}
            />
            <p>Características</p>
          </div>
          <i
            className={css({
              "fal fa-chevron-down": true,
              collapsed: collapsed === "characteristics",
            })}
          />
        </div>

        {collapsed === "characteristics" && (
          <div className={styles.content}>
            <p className={styles.label}>Defina o tipo</p>
            <Checkbox
              className="mb-15"
              label="Ensolarado"
              checked={weather?.values?.includes(CLIMATE_FEATURE.CLEAR)}
              onClick={() => {
                if (weather?.values?.includes(CLIMATE_FEATURE.CLEAR)) {
                  this.setPayloadKeyValue("weather", {
                    values: (weather?.values || []).filter(
                      (f) => f != CLIMATE_FEATURE.CLEAR
                    ),
                  });
                } else {
                  this.setPayloadKeyValue("weather", {
                    values: [...(weather?.values || []), CLIMATE_FEATURE.CLEAR],
                  });
                }
              }}
            />
            <Checkbox
              className="mb-15"
              label="Parcialmente nublado"
              checked={weather?.values?.includes(CLIMATE_FEATURE.PARTLY_CLOUDY)}
              onClick={() => {
                if (weather?.values?.includes(CLIMATE_FEATURE.PARTLY_CLOUDY)) {
                  this.setPayloadKeyValue("weather", {
                    values: (weather?.values || []).filter(
                      (f) => f != CLIMATE_FEATURE.PARTLY_CLOUDY
                    ),
                  });
                } else {
                  this.setPayloadKeyValue("weather", {
                    values: [
                      ...(weather?.values || []),
                      CLIMATE_FEATURE.PARTLY_CLOUDY,
                    ],
                  });
                }
              }}
            />
            <Checkbox
              className="mb-15"
              label="Nublado"
              checked={weather?.values?.includes(CLIMATE_FEATURE.CLOUDY)}
              onClick={() => {
                if (weather?.values?.includes(CLIMATE_FEATURE.CLOUDY)) {
                  this.setPayloadKeyValue("weather", {
                    values: (weather?.values || []).filter(
                      (f) => f != CLIMATE_FEATURE.CLOUDY
                    ),
                  });
                } else {
                  this.setPayloadKeyValue("weather", {
                    values: [
                      ...(weather?.values || []),
                      CLIMATE_FEATURE.CLOUDY,
                    ],
                  });
                }
              }}
            />
            <Checkbox
              className="mb-15"
              label="Chovendo"
              checked={weather?.values?.includes(CLIMATE_FEATURE.RAIN)}
              onClick={() => {
                if (weather?.values?.includes(CLIMATE_FEATURE.RAIN)) {
                  this.setPayloadKeyValue("weather", {
                    values: weather?.values.filter(
                      (f) => f != CLIMATE_FEATURE.RAIN
                    ),
                  });
                  this.setPayloadKeyValue("rain", { selected: false });
                } else {
                  this.setPayloadKeyValue("weather", {
                    values: [...weather?.values, CLIMATE_FEATURE.RAIN],
                  });
                  this.setPayloadKeyValue("rain", { selected: true });
                }
              }}
            />

            {rain?.selected && (
              <>
                <p className={styles.label}>Defina a quantidade de chuva</p>
                <div className="d-flex align-center mt-25">
                  <BaseCurrencyInput
                    className="w-100 mr-15"
                    suffix={" mm"}
                    prefix={""}
                    design="two"
                    precision={0}
                    label="Faixa mín"
                    value={rain?.min}
                    onChange={(value) => {
                      this.setPayloadKeyValue("rain", {
                        min: value,
                      });
                    }}
                  />
                  <BaseCurrencyInput
                    className="w-100"
                    suffix={" mm"}
                    prefix={""}
                    design="two"
                    precision={0}
                    label="Faixa máx"
                    value={rain?.max}
                    onChange={(value) => {
                      this.setPayloadKeyValue("rain", {
                        max: value,
                      });
                    }}
                  />
                </div>
              </>
            )}
          </div>
        )}
      </div>
    );
  }

  render() {
    const { visible, node, onClose, onSave } = this.props;
    const { payload } = this.state;
    const { quantity } = payload || { quantity: {} };

    return (
      <Drawer
        visible={visible}
        onClose={() => onClose()}
        title={BoxTitles.ClimateProfileFilterForm}
      >
        <div className={styles.scrollContainer}>
          {this.renderTemperature()}
          {this.renderMoisture()}
          {this.renderWeatheRain()}

          <div className={styles.hairlineB} />

          <p className={styles.label}>Quantidade de pedidos neste padrão</p>
          <BaseCurrencyInput
            className="w-100"
            suffix={" conversões"}
            prefix={""}
            precision={0}
            value={quantity?.exact}
            onChange={(value) => {
              this.setPayloadKeyValue("quantity", {
                exact: value,
              });
            }}
          />
        </div>

        <div className={styles.footer}>
          <Button
            className="w-100"
            onClick={() =>
              onSave({ ...node, data: { ...node.data, ...payload } })
            }
            design="primary"
          >
            Salvar
          </Button>
        </div>
      </Drawer>
    );
  }
}
